<template>
  <div>
    <popup v-if="!isAdminMode"></popup>
    <components-renderer :components="components"></components-renderer>
    <!-- <component-view :seq="theme.home"></component-view> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

import theme from '@/component/js/theme'
import ComponentsRenderer from '@/component/common/components-renderer.js'

export default {
  mixins: [theme],
  computed: {
    ...mapState(['designPost']),
    components () {
      console.log('this.theme.home', this.theme)
      if (this.designPost.seq.hasOwnProperty(this.theme.home) && this.designPost.seq[this.theme.home].hasOwnProperty('components')) {
        return this.designPost.seq[this.theme.home].components
      } else if (this.designPost.key.hasOwnProperty(this.theme.home) && this.designPost.key[this.theme.home].hasOwnProperty('components')) {
        return this.designPost.key[this.theme.home].components
      } else {
        return []
      }
    }
  },
  components: {
    Popup: () => import('@/app/user/component/Popup'),
    ComponentsRenderer
    // ComponentView: () => import('@/app/board/ComponentView')
  }
}
</script>
